import { render } from "./PhoneBook.vue?vue&type=template&id=11b2ceb0&scoped=true"
import script from "./PhoneBook.vue?vue&type=script&lang=js"
export * from "./PhoneBook.vue?vue&type=script&lang=js"

import "./PhoneBook.vue?vue&type=style&index=0&id=11b2ceb0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b2ceb0"]])

export default __exports__